import { useQuery } from '@tanstack/react-query';

import { statsApi, statsKeys, type TriageStatsParams } from './api';

/**
 * The accuracy figure of the week.
 *
 * **Always refetched when the screen mounts, and never considered fresh.** The number
 * moves every time somebody presses a button in the inbox, and the inbox is a different
 * feature, so it cannot invalidate this key without reaching across a boundary the repo
 * forbids. A cached percentage after six corrections would contradict the button that
 * just said "cuenta para la cifra de acierto de la semana", and a figure that lies about
 * itself is worse than one that takes 200 ms to arrive.
 *
 * The back computes this on request with no cache of its own and the volume is hundreds
 * of rows a week, so there is nothing here worth optimising.
 */
export function useTriageStats(
  params: TriageStatsParams = {},
  { enabled = true }: { enabled?: boolean } = {},
) {
  return useQuery({
    queryKey: statsKeys.triage(params),
    queryFn: () => statsApi.triage(params),
    // Off while a custom period is half typed: a window with one date is not a query.
    enabled,
    staleTime: 0,
    refetchOnMount: 'always',
  });
}
